import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const Teams: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Teams</h1>
      <p className="section-description">
        Manage team structures, roles, and collaboration settings within the organization.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Team Management</h3>
              <p className="feature-description">
                Organize and manage teams:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and structure teams</li>
                <li>Assign team roles</li>
                <li>Manage team members</li>
                <li>Set team objectives</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Team Collaboration</h3>
              <p className="feature-description">
                Facilitate team collaboration:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Share team resources</li>
                <li>Manage team projects</li>
                <li>Track team progress</li>
                <li>Coordinate team activities</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Define clear team roles and responsibilities</li>
            <li>Foster open communication</li>
            <li>Set measurable team goals</li>
            <li>Regularly review team performance</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Teams; 